import { cn } from '@lib/util/cn';
import { Text } from '@modules/common/components/text';
import type { VariantPrice } from 'types/view-models';

export default function PreviewPrice({ price }: { price: VariantPrice }) {
  if (!price) {
    return null;
  }

  return (
    <div className="flex items-center gap-x-2">
      {price.price_type === 'sale' && (
        <Text
          className="text-sm line-through text-fg-neutral-soft"
          data-testid="original-price"
        >
          {price.original_price}
        </Text>
      )}
      <Text
        className={cn('typography-paragraph-lg', {
          'text-fg-danger-strong': price.price_type === 'sale',
          'text-fg-neutral-strong': price.price_type !== 'sale',
        })}
        data-testid="price"
      >
        {price.has_multiple_prices
          ? `From ${price.calculated_price}`
          : price.calculated_price}
      </Text>
    </div>
  );
}
